import BasicInfo from '../../../components/Profile/BasicInfo/BasicInfo';
import { reduxForm } from 'redux-form';

const RegisterBasics = reduxForm({
    form: 'basics',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount:true
})(BasicInfo);

export default RegisterBasics;